export const GENERIC_ERROR_MESSAGE =
  'Oops! Something went wrong!\nHelp us improve your experience by sending an error report';
export const MULTIPLE_SESSION_ERROR = 'Multiple session found';
export const SESSION_NOT_FOUND = 'No session found';
export const SESSION_EXPIRED = 'Session expired, please log in again';
export const MAINTENANCE = 'Maintenance';
export const AUTHORIZATION_NOT_FOUND = 'No Authorization header was found';
export const STRIPE_API_VERSION = '2025-09-30.clover';
